var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card"},[_c('div',{directives:[{name:"dynamic-content",rawName:"v-dynamic-content:iquote_not_found_error_text",arg:"iquote_not_found_error_text"}],staticClass:"card-body"})])])}
var staticRenderFns = []

export { render, staticRenderFns }